export default class ApiEndPoint {
  static otp = "/otp";
  static email = "/email";
  static send = "/send";
  static v1 = "/v1";
  static verify = "/verify";
  static auth = "/auth";
  static user = "/user";
  static logout = "/logout";
  static ondemand = "/ondemand";
  static filter = "/filter";
  static download = "/download";
  static upload = "/upload";
  static bulk = "/bulk";
  static error = "/error";
  static history = "/history";
  static reliance = "/reliance";
  static brand = "/brand";
  static list = "/list";
  static orderStatus = "/order-status";
}
